import React, { useState, useRef } from "react";
import { DateRangePicker, createStaticRanges } from "react-date-range";
import Popover from "../popover";
import DateCalenderIcon from "../../icons/dateCalender";
import styles from "./style.module.css";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  startOfYear,
  endOfYear,
  format
} from 'date-fns';

const defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  startOfLastSevenDay: startOfDay(addDays(new Date(), -7)),
  startOfLastThirtyDay: startOfDay(addDays(new Date(), -30)),
  startOfLastNintyDay: startOfDay(addDays(new Date(), -90)),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  startOfYear: startOfYear(new Date()),
  endOfYear: endOfYear(new Date()),
  startOfLast12Months: startOfDay(addMonths(new Date(), -12)),
  endOfLast12Months: endOfDay(new Date())
};

const customDateObjects = [
  {
    label: 'Today',
    range: () => ({
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday
    })
  },
  {
    label: 'Yesterday',
    range: () => ({
      startDate: defineds.startOfYesterday,
      endDate: defineds.endOfYesterday
    })
  },
  {
    label: 'Last Week',
    range: () => ({
      startDate: defineds.startOfLastWeek,
      endDate: defineds.endOfLastWeek
    })
  },
  {
    label: 'Last Month',
    range: () => ({
      startDate: defineds.startOfLastMonth,
      endDate: defineds.endOfLastMonth
    })
  },
  {
    label: 'Last 12 Months',
    range: () => ({
      startDate: defineds.startOfLast12Months,
      endDate: defineds.endOfLast12Months
    })
  },
  {
    label: 'Year to Date',
    range: () => ({
      startDate: defineds.startOfYear,
      endDate: defineds.endOfToday
    })
  }
];

const DateInput = ({ customClass = "", onDateChange }) => {
  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  });

  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);

  const handleOpenButton = () => {
    setIsOpen((prev) => !prev);
  };

  const handleCloseButton = () => {
    setIsOpen(false);
  };

  const handleDateChange = (item) => {
    setState({ ...state, ...item });
    setDateRange({
      startDate: format(item.selection.startDate, "dd MMM yyyy"),
      endDate: format(item.selection.endDate, "dd MMM yyyy"),
    });
    onDateChange && onDateChange(item);
  };

  const handleResetDate = () => {
    setState({
      ...state,
      selection: {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    });
    setDateRange({ startDate: "", endDate: "" });
    onDateChange && onDateChange({ selection: { startDate: "", endDate: "" } });
    setIsOpen(false);
  };

  const staticRanges = [
    ...createStaticRanges(customDateObjects)
  ];

  return (
    <div className={`${styles.date_input} ${customClass}`}>
      <button
        type="button"
        ref={buttonRef}
        onClick={handleOpenButton}
        className={`${isOpen ? styles.active : ""}`}
      >
        {dateRange.startDate && dateRange.endDate ? (
          <span>{`${dateRange.startDate} - ${dateRange.endDate}`}</span>
        ) : (
          <span>Select Date Range</span>
        )}
        <DateCalenderIcon />
      </button>
      <Popover
        open={isOpen}
        buttonRef={buttonRef}
        onClose={handleCloseButton}
        customClass={styles.date_range_popover}
        maxWidth="auto"
      >
        <DateRangePicker
          onChange={(item) => handleDateChange(item)}
          moveRangeOnFirstSelection={false}
          showDateDisplay={false}
          ranges={[state.selection]}
          showSelectionPreview={true}
          editableDateInputs={false}
          inputRanges={[]}
          color={"#FF0800"}
          staticRanges={staticRanges}
        />
        <button type="button" onClick={handleResetDate}>
          Reset
        </button>
      </Popover>
    </div>
  );
};

export default DateInput;
